import React, { useMemo } from 'react'

import { Box } from '@mantine/core'
import { isEqual } from 'lodash-es'

import { SelectionFooterProps } from './selection-footer'
import { DEFAULT_TABLE_PROPS } from '../../constants'
import useHeaderFooterStyles from '../../styles/useHeaderFooterStyles'
import SelectionColumnCheckbox from '../Columns/SelectionColumn/SelectionColumnCheckbox'

const SelectionFooter = <T,>({
  selectionState: { selectedRows, setSelectedRows },
  allIdsOnActivePage,
  columnsCount,
  tableProps,
  selectionActions: SelectionActions,
}: SelectionFooterProps<T>): React.ReactElement => {
  const checked = useMemo(() => {
    return isEqual(allIdsOnActivePage, selectedRows)
  }, [selectedRows, allIdsOnActivePage])

  const indeterminate = useMemo(() => {
    return (
      selectedRows.length > 0 && selectedRows.length < allIdsOnActivePage.length
    )
  }, [selectedRows, allIdsOnActivePage])

  const { classes } = useHeaderFooterStyles({
    tableFontSize: tableProps?.fontSize ?? DEFAULT_TABLE_PROPS.fontSize,
  })

  return (
    <>
      <tr>
        <th className={classes.th}>
          <Box
            py="xs"
            px="md"
          >
            <SelectionColumnCheckbox
              {...{
                checked,
                indeterminate,
                onChange: checked
                  ? () => setSelectedRows([])
                  : indeterminate || selectedRows.length === 0
                    ? () => setSelectedRows(allIdsOnActivePage)
                    : () => setSelectedRows([]),
              }}
            />
          </Box>
        </th>
        <th colSpan={columnsCount - 1}>
          {React.isValidElement(SelectionActions) && (
            <Box>{SelectionActions}</Box>
          )}
        </th>
      </tr>
    </>
  )
}

export default SelectionFooter
